import { RootDocument } from '../../types';
import { useRootDocument } from '../useRootDocument/useRootDocument';

export function useRootDocumentOrFail<T = RootDocument>(): T {
  const rootDocument = useRootDocument<T>();

  if (rootDocument === undefined) {
    throw new Error('Cannot return root document: root document is missing.');
  }

  return rootDocument as T;
}
